<script>
export default {
  functional: true,
  props: {
    prospect: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  render(h, ctx) {
    return (
      <div class='prospect-unsubscribed-notice'>
        <strong>{ctx.props.prospect.firstName} has unsubscribed.</strong> You
        cannot send anymore messages.
      </div>
    );
  },
};
</script>

<style lang="scss" scoped>
@import '@design';

.prospect-unsubscribed-notice {
  background: $color-red;
  border-radius: $base-border-radius;
  color: white;
  font-size: 1.4rem;
  line-height: 2.4rem;
  margin: 1.8rem 0 2.8rem;
  padding: 1rem 1.8rem;
}
</style>
